import React, { useState, useEffect, useContext } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import Utils from "../../../Common/Utils";
import AppSettings from "../../../Settings/AppSettings";
import Paginator from "../../Common/Paginator";
import AuthManager from "../../../Common/AuthManager";
import { VMContext } from "./vmContext";
import Bootbox from "../../../Common/BootBoxManager";

function VMQuerySetList(props) {
  let VMContextdata = useContext(VMContext);
  var [loadError, setLoadError] = React.useState(false);
  var [vquerySetList, setvquerySetList] = React.useState([]);
  var [vquerySetListCopy, setvquerySetListCopy] = React.useState([]);
  var [loading, setLoading] = React.useState(false);
  var [listRefreshCounter, setlistRefreshCounter] = React.useState(1);
  var [recordPerPage, setRecordPerPage] = useState(10);

  var [pageRangeArray, setPageRangeArray] = useState([5, 10, 15, 25, 50, 100]);
  var [filteredvquerySet, setFilteredvquerySet] = React.useState([]);
  var [searchval, setSearchVal] = useState("");
  const pageRange = 10;

  function get_data_from_date(dt, ret = "date") {
    if (Utils.isUndefinedOrNull(dt)) return null;
    var ss = dt.split("T");
    if (ret === "date") return ss[0];
    else {
      var tt = ss[1].split(".");
      return tt[0];
    }
  }

  async function LoadQuerySetList() {
    setLoading(true);
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doGet(
      api_base_url + "versionmanagement/queryset/list",
      null,
      null,
      AuthManager.getGmsToken()
    );
    setLoadError(ret.errorfound);
    if (!ret.errorfound) {
      await setvquerySetList(ret.data.data);
      let tempVar = JSON.parse(JSON.stringify(ret.data.data));
      await setvquerySetListCopy(tempVar);
      setlistRefreshCounter((n) => n + 1);
    }
    setLoading(false);
  }

  async function handle_page_change(pagenumber, paged_data) {

    if (paged_data !== undefined) {
      var tt = paged_data;
      setvquerySetList(tt);
    }
  }

  async function handle_log_search(val) {
    if (vquerySetList.length === 0)
      setvquerySetList((t) => (t = filteredvquerySet));
    val = val.toString().trim().toLowerCase();
    setSearchVal((n) => val);
  }

  async function handle_recordsperpage_change(newval) {
    setRecordPerPage(parseInt(newval));
  }

  function get_filtered_records() {
    let filteredData = JSON.parse(JSON.stringify(vquerySetListCopy));

    if (!Utils.isEmpty(searchval)) {
      var seartext = searchval;
      filteredData = filteredData.filter((item) => {
        if (item.name != null && item.name.toLowerCase().includes(seartext)) {
          return true;
        } else {
          return false;
        }
      });
    }
    setFilteredvquerySet((n) => filteredData);
  }

  async function hande_record_change(e, index) {
    let temp = JSON.parse(JSON.stringify(vquerySetList));
    temp[index][e.target.name] =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setvquerySetList(temp);
  }

  function record_has_changes(index) {
    return (
      JSON.stringify(vquerySetList[index]) !==
      JSON.stringify(vquerySetListCopy[index])
    );
  }

  async function save_record_changes(item, index) {
    let temp = JSON.parse(JSON.stringify(vquerySetList));
    var updateProcessingKey = "UpdateProcessing";
    temp[index][updateProcessingKey] = {
      message: null,
      done: false,
      error: false,
    };
    setvquerySetList(temp);

    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let res = await ServiceWrapper.doPost(
      api_base_url + "versionmanagement/queryset/update/" + item.uid,
      vquerySetList[index],
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        let temp = JSON.parse(JSON.stringify(vquerySetList));
        temp[index][updateProcessingKey] = {
          message: "Updated",
          done: true,
        };
        setvquerySetList(temp);
        setTimeout(() => {
          let tem = JSON.parse(JSON.stringify(temp));
          tem[index]["UpdateProcessing"] = null;
          setvquerySetList(tem);
          setvquerySetListCopy(tem);
        }, 3000);
      } else {
        let temp = JSON.parse(JSON.stringify(vquerySetList));
        temp[index][updateProcessingKey] = {
          message: res.data.message,
          done: true,
          error: true,
        };
        setvquerySetList(temp);
      }
    } else {
      let temp = JSON.parse(JSON.stringify(vquerySetList));
      temp[index][updateProcessingKey] = {
        message: "Error occured",
        done: true,
        erroe: true,
      };
      setvquerySetList(temp);
    }
  }

  async function delete_record(item, index) {
    let temp = JSON.parse(JSON.stringify(vquerySetList));
    var updateProcessingKey = "DeleteProcessing";
    temp[index][updateProcessingKey] = {
      message: null,
      done: false,
      error: false,
    };
    setvquerySetList(temp);
    setvquerySetListCopy(temp);

    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let res = await ServiceWrapper.doGet(
      api_base_url + "versionmanagement/queryset/delete/" + item.uid,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        let temp = JSON.parse(JSON.stringify(vquerySetList));
        temp.pop(index);
        setvquerySetList(temp);
        setvquerySetListCopy(temp);
      } else {
        let temp = JSON.parse(JSON.stringify(vquerySetList));
        temp[index][updateProcessingKey] = {
          message: res.data.message,
          done: true,
          error: true,
        };
        setvquerySetList(temp);
        setvquerySetListCopy(temp);
      }
    } else {
      let temp = JSON.parse(JSON.stringify(vquerySetList));
      temp[index][updateProcessingKey] = {
        message: "Error occured",
        done: true,
        erroe: true,
      };
      setvquerySetList(temp);
      setvquerySetListCopy(temp);
    }
  }

  useEffect(() => {
    get_filtered_records();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchval, listRefreshCounter]);

  useEffect(() => {
    LoadQuerySetList();
  }, [VMContextdata.QuerySetReleadCounter]);

  return (
    <React.Fragment>
      {loading && (
        <div>
          <div className="p-2 bg-white alert alert-primary small" role="alert">
            <span className="fas fa-circle-notch fa-spin" />
            &nbsp;
            <strong>Loading Query Set</strong>
          </div>
        </div>
      )}
      {!loading && (
        <React.Fragment>
          {vquerySetListCopy.length > 0 && !loadError && (
            <div>
              <div className="float-start">
                <h1 className="h6">List of query set</h1>
              </div>
              <div className="float-end">
                <select
                  id="inputState"
                  className="border form-control-sm border-secondary"
                  value={recordPerPage}
                  onChange={(e) => {
                    handle_recordsperpage_change(e.target.value);
                  }}
                >
                  {pageRangeArray.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-light btn-sm"
                  style={{ color: "#00A2E5" }}
                  onClick={() => LoadQuerySetList()}
                >
                  <i className="fa fa-sync-alt" />
                </button>
              </div>
            </div>
          )}

          {vquerySetListCopy.length > 0 && !loadError && (
            <div>
              <input
                type="text"
                className="border form-control form-control-sm border-secondary float-end"
                placeholder="Search vquerySet"
                onChange={(e) => handle_log_search(e.target.value)}
              />
            </div>
          )}
          <div className="row">&nbsp;</div>
          <div className="row">&nbsp;</div>
          <div className="table-responsive">
            {vquerySetList.length > 0 && !loadError && (
              <React.Fragment>
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th width="10%">Name</th>
                      <th width="10%">Start</th>
                      <th width="10%">End</th>
                      <th width="10%">Created By</th>
                      <th width="10%">Queries</th>
                      <th width="15%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {vquerySetList.map((item, index) => (
                      <tr key={"vquerySet" + index}>
                        <td>
                          <div className="mt-2 form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckChecked"
                              name="active"
                              disabled={item.end_date === null}
                              checked={item.active || false}
                              onChange={(e) => {
                                hande_record_change(e, index);
                              }}
                            />

                            <input
                              type="text"
                              name="name"
                              onChange={(e) => {
                                hande_record_change(e, index);
                              }}
                              value={item.name}
                            />
                          </div>
                        </td>

                        <td>
                          {get_data_from_date(item.start_date)}
                          &nbsp;
                          <small className="text-muted">
                            <strong>
                              {get_data_from_date(item.start_date, "time")}
                            </strong>
                          </small>
                        </td>
                        <td>
                          {item.end_date === null && (
                            <span className="badge bg-warning text-dark">
                              Current Set
                            </span>
                          )}
                          {get_data_from_date(item.end_date)}
                          &nbsp;
                          <small className="text-muted">
                            <strong>
                              {get_data_from_date(item.end_date, "time")}
                            </strong>
                          </small>
                        </td>
                        <td>{item.username}</td>
                        <td>
                          <span className="badge bg-info text-dark">
                            {item.query_count}
                          </span>
                        </td>

                        <td className="float-end">
                          {!Utils.isUndefinedOrNull(item.UpdateProcessing) && (
                            <>
                              {!item.UpdateProcessing.done && (
                                <>
                                  <span className="fas fa-circle-notch fa-spin" />
                                  &nbsp;
                                  <span className="text-success">
                                    <strong>updating</strong>
                                  </span>
                                </>
                              )}
                              {item.UpdateProcessing.done && (
                                <>
                                  {!item.UpdateProcessing.error && (
                                    <span className="text-success">
                                      <strong>
                                        {item.UpdateProcessing.message}
                                      </strong>
                                    </span>
                                  )}
                                  {item.UpdateProcessing.error && (
                                    <span className="text-danger">
                                      <strong>
                                        {item.UpdateProcessing.message}
                                      </strong>
                                    </span>
                                  )}
                                </>
                              )}
                              &nbsp;
                            </>
                          )}

                          {!Utils.isUndefinedOrNull(item.DeleteProcessing) && (
                            <>
                              {!item.DeleteProcessing.done && (
                                <>
                                  <span className="fas fa-circle-notch fa-spin" />
                                  &nbsp;
                                  <span className="text-success">
                                    <strong>Deleting</strong>
                                  </span>
                                </>
                              )}
                              {item.DeleteProcessing.done && (
                                <>
                                  {!item.DeleteProcessing.error && (
                                    <span className="text-success">
                                      <strong>
                                        {item.DeleteProcessing.message}
                                      </strong>
                                    </span>
                                  )}
                                  {item.DeleteProcessing.error && (
                                    <span className="text-danger">
                                      <strong>
                                        {item.DeleteProcessing.message}
                                      </strong>
                                    </span>
                                  )}
                                </>
                              )}
                              &nbsp;
                            </>
                          )}

                          {record_has_changes(index) && (
                            <>
                              <i
                                className="fas fa-check"
                                style={{ cursor: "pointer" }}
                                onClick={() => save_record_changes(item, index)}
                              />
                              &nbsp;
                            </>
                          )}

                          {item.end_date !== null && (
                            <>
                              <i
                                className="fas fa-trash"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  Bootbox.confirm(
                                    "Delete '" + item.name + "' Query Set ?",
                                    `Do you really want to delete the <strong>${item.name}</strong> Query Set ? This cannot be undone.`,
                                    false,
                                    [delete_record, item, index]
                                  )
                                }
                              />
                              &nbsp;
                              <i
                                className="fas fa-arrow-alt-circle-up"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  VMContextdata.setCurrentRealeasingSetId(
                                    item.uid
                                  );
                                  setTimeout(() => {
                                    Utils.click_button("rset-tab");
                                  }, 1000);
                                }}
                              />
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </React.Fragment>
            )}
            <div className="float-end">
              <Paginator
                recordPerPage={recordPerPage}
                totalRecords={filteredvquerySet.length}
                data={filteredvquerySet}
                pageRange={pageRange}
                onPageChange={handle_page_change}
              />
            </div>
            {vquerySetList.length === 0 &&
              vquerySetListCopy.length > 0 &&
              !loadError && (
                <div className="bg-white alert alert-danger" role="alert">
                  <strong>Sorry!</strong>, No records found during our search
                </div>
              )}
            {vquerySetListCopy.length === 0 && !loadError && (
              <div className="bg-white alert alert-danger" role="alert">
                <strong>Sorry!</strong>, No records found
              </div>
            )}
            {loadError && (
              <div className="bg-white alert alert-danger" role="alert">
                <strong>Oops</strong>, An error occurred . Press{" "}
                <button
                  type="button"
                  className="btn btn-light btn-sm"
                  style={{ color: "#00A2E5" }}
                  onClick={() => LoadQuerySetList()}
                >
                  <i className="fa fa-sync-alt" />
                </button>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default VMQuerySetList;
